import LoadingDots from "./LoadingDots";

## Basic Usage

<LoadingDots>Loading</LoadingDots>

---

## Different Text

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <LoadingDots>Saving</LoadingDots>
  <LoadingDots>Processing</LoadingDots>
  <LoadingDots>Please wait</LoadingDots>
  <LoadingDots>Connecting</LoadingDots>
</div>

---

## Without Text

<LoadingDots />

---

## In Button Context

<button
  style={{
    padding: "8px 16px",
    borderRadius: "6px",
    border: "none",
    background: "#3b82f6",
    color: "white",
    cursor: "not-allowed",
    opacity: 0.8,
  }}
  disabled
>
  <LoadingDots>Submitting</LoadingDots>
</button>

---

## Status Messages

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <div style={{ color: "#666" }}>
    <LoadingDots>Uploading file</LoadingDots>
  </div>
  <div style={{ color: "#666" }}>
    <LoadingDots>Analyzing data</LoadingDots>
  </div>
  <div style={{ color: "#666" }}>
    <LoadingDots>Generating report</LoadingDots>
  </div>
</div>

---

## In a Card

<div
  style={{
    border: "1px solid #e5e5e5",
    borderRadius: "8px",
    padding: "2rem",
    textAlign: "center",
    background: "#fafafa",
  }}
>
  <LoadingDots>Fetching results</LoadingDots>
</div>


